import React, { useState } from 'react';
import { Form, FormElement, Field } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';
import {
  FormCheckbox
} from "src/shared/components/formControls";
import { useSelector } from 'react-redux';
import PickPolicyDropdown from 'src/shared/components/dropdowns/PickPolicyDropdown';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { getWarehousesLookups } from 'src/slices/warehousesLookups';
import { addToBL } from 'src/fetch/inventoryUnit';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';
import LineItemsLookup from 'src/shared/components/dropdowns/LineItemsLookup';
import { getAddToBLTypes } from 'src/slices/addToBLTypes';

const AddToBLForm = ({
  data,
  onClose
}) => {

  const [lineItems, setLineItems] = useState([]);
  const [needReload, setNeedReload] = useState(false);
  const [addedFrom, setAddedFrom] = useState(null);

  const types = useSelector(getAddToBLTypes);

  const convertValuesToSubmit = ({
    pickPolicy,
    ...others
  }) => ({
    pickPolicy: typeof pickPolicy === 'object' ? pickPolicy?.value : pickPolicy,
    ...others
  });

  const handleSubmit = async (data) => {

    data = convertValuesToSubmit(data);

    const result = {
      ...data,
      addedBy: data.type,
      addedFrom: addedFrom,
      lineItems: lineItems.filter(l => l.selected).map(l => l.id)
    };

    await addToBL(result).then(() => {
      toastr('success', 'Successfully added to BL');
      onClose(true);
    }).catch((error) => {
      errorToastr({
        error,
        messagePrefix: 'Failed to add to BL!'
      });
    });
  };

  const handleCancelClick = () => {
    onClose();
  };

  const onReload = () => {
    setNeedReload(false);
  };

  const warehouses = useSelector(getWarehousesLookups);
  const warehouse = (item) => warehouses.find(c => c.id === item.dataItem.warehouseId);

  const handleLineItemSelected = (item, selected) => {
    if (item) {
      let currLineItems = lineItems;
      currLineItems.find(l => l.id === item.dataItem.id).selected = selected;
      setLineItems(currLineItems);
    }
  };

  return (
    <Form onSubmit={handleSubmit}
      initialValues={data}
      key={JSON.stringify(data)}
      id='add-to-bl'
      render={(formRenderProps) => (
        <FormElement>
          <fieldset className={"k-form-fieldset"}>

            <Field required id={'pickPolicy'} name={'pickPolicy'} label={'Pick Policy'} component={PickPolicyDropdown} />

            <br />
            <LineItemsLookup label={`Search by ${types.find(t => t.value === data.type).description}...`} type={data.type} setLineItems={setLineItems} setNeedReload={setNeedReload} setAddedFrom={setAddedFrom} />

            <br />

            <Grid
              data={lineItems}
              pageable={false}
              needReload={needReload}
              onReload={onReload}
              exportEnabled={false}
            >
              <GridColumn
                title="Select"
                field="selected"
                editable={true}
                width={'40px'}
                cell={(item) => (
                  <td><FormCheckbox value={item.selected} onChange={e => handleLineItemSelected(item, e.value)} /></td>
                )}
              />
              <GridColumn title='MR #' field='id' width={'60px'} />
              <GridColumn title='Pro No.' field='proNumber' />
              <GridColumn title='Equipment #' field='equipmentNumber' />
              <GridColumn title='Warehouse' field='warehouseId' cell={(item) => (
                <td>{warehouse(item)?.whse}</td>
              )} />
              <GridColumn title='Product Code' field='productId' />
              <GridColumn title='1st Qty' field='masterQuantity' />
              <GridColumn title='1st UOM' field='masterUomId' />
              <GridColumn title='2nd Qty' field='secondaryQuantity' />
              <GridColumn title='2nd UOM' field='secondaryUomId' />
              <GridColumn title='Lbs' field='lbs' />
              <GridColumn title='KGs' field='kgs' />
              <GridColumn
                title='Arrive Date'
                field='arriveDate'
                editor='date'
                format='{0:d}'
              />
            </Grid>

            <div className="k-form-buttons">
              <Button primary icon="cancel" onClick={handleCancelClick} style={{ marginRight: '10px' }}>Cancel</Button>
              {<Button primary icon="save" type={'submit'} disabled={!formRenderProps.allowSubmit}>Save</Button>}
            </div>

          </fieldset>
        </FormElement >
      )}>
    </Form >
  );
};

export default AddToBLForm;
